import React from 'react';

import { TypeAutoriteFourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { TypeAfFormValues } from 'types/referentiels/TypeAf';

import { buildRequestDto } from '../utils';

import { ModalEditionTypeAf } from './ModalEditionTypeAf';

interface ModalDetailsProps {
  visible: boolean;
  close: () => void;
  refreshDashboard: () => void;
}

function ModalCreate({
  visible,
  close,
  refreshDashboard,
}: ModalDetailsProps): React.ReactElement {
  const initials: TypeAfFormValues = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: TypeAfFormValues) =>
      AdminFonctionnelControllerApi.createTypeAfUsingPOST(
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: TypeAutoriteFourriereViolationDtoFormFieldEnum,
      values: TypeAfFormValues,
    ) =>
      AdminFonctionnelControllerApi.validateCreateTypeAFFieldUsingPOST(
        field,
        buildRequestDto(values),
      ),
    response => response.typeAutoriteFourriereViolationDto ?? [],
  );

  return (
    <ModalEditionTypeAf
      close={close}
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      visible={visible}
      title={"Créer un type d'AF"}
      validate={validate}
    />
  );
}

export default ModalCreate;
